import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryResult,
} from '@tanstack/react-query'
import { Spreadsheet } from '../../../../lib/Types'
import * as SpreadsheetAPI from '../API/SpreadsheetAPI'

export const useCreateSpreadsheet = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => SpreadsheetAPI.createSpreadsheet(),
    onSuccess: (newSpreadsheet: Spreadsheet) => {
      queryClient.setQueryData(
        ['spreadsheets'],
        (oldData: Spreadsheet[]) => [...(oldData ?? []), newSpreadsheet],
      )
    },
  })
}

export const useSpreadsheets = (): UseQueryResult<Spreadsheet[]> => {
  return useQuery({
    queryKey: ['spreadsheets'],
    queryFn: () => SpreadsheetAPI.getSpreadsheets(),
    staleTime: Infinity,
  })
}
